/**
 * Updates a user's locale after making a selection from a region selector menu
 *
 * @param {string} userLocale
 */

/** Clears cookies when a user changes locales. This in effect causes the OneTrust Banner to reappear. 
 * This function iterates through each cookie and sets the experation date to the current time, effectively expiring or deleting all cookies on the current domain.
*/
const clearCookies = () => {
  document.cookie.split(';').forEach(userCookie => {
    document.cookie = userCookie.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
  });
};

const updateLocationUrl = userLocale => {
  clearCookies();

  const url = new URL(window.location.origin);
  url.pathname = userLocale.location == 'Global' ? '' : userLocale.url;

  sessionStorage.setItem('userLocation', userLocale.displayLocation);
  sessionStorage.setItem('userGeoUrl', userLocale.url);
  localStorage.setItem('geoip_iso', userLocale.geoIso_location);

  window.location.href = url.href;
};

export default updateLocationUrl;
